import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { animateScroll } from 'react-scroll';
import Section from 'components/Section';
import TextField from 'components/TextField';
import NavigationButtons from 'components/NavigationButtons';
import i18n from 'utils/translate';
import { numbersOnly } from 'utils/validators';
import { toast } from 'react-toastify';
import ErrorMessage from 'components/ErrorMessage';
import { linkTypeShape } from 'utils/types';
import RadioButtonGroup from 'components/RadioButtonGroup';
import { insuranceTypes } from '../../constants';
import { debounce } from 'underscore';
import { CALC_API_DEBOUNCE_DURATION } from '../../constants';
import mobile from 'is-mobile';
import DropdownField from 'components/DropdownField';

const propTypes = {
  type: PropTypes.string,
  insuranceNumber: PropTypes.number, // policyNumber or offerNumber
  onChange: PropTypes.func.isRequired,
  backLink: PropTypes.shape(linkTypeShape),
  nextLink: PropTypes.shape(linkTypeShape).isRequired
};

const defaultProps = {
  onChange: console.log,
  data: {}
};

class ContractTypeData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.data,
      type: props.data.type ?? insuranceTypes.policyNumber,
      submitted: false,
      validForm: false,
      isMobile: mobile()
    };
  }

  handleSubmit = () => {
    const {
      nextLink: { go } = {
        go: () => {}
      },
      onChange
      // getPolicyPaymentDetails
    } = this.props;
    const form = this.refs.form;

    if (form.checkValidity && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    this.setState(() => {
      onChange(this.state);
      // getPolicyPaymentDetails();

      // TODO
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'onlinepayment',
          formname: 'OnlineFormMacedonia',
          action: 'Ihre Daten'
        });
      }

      go();
    });
  };

  handleDataChange = (data, key) => {
    const { submitted } = this.state;

    this.setState(
      {
        [`${key}`]: data
      },
      () => {
        this.getPaymentDetails();
        if (submitted) {
          this.setState({
            validForm: this.refs.form.checkValidity()
          });
        }
      }
    );
  };

  getPaymentDetails() {
    const { type, insuranceNumber, birthdate } = this.state;

    if (type === insuranceTypes.policyNumber && !!insuranceNumber && !!birthdate) {
      this.requestPaymentDetails();
    }
    if (type === insuranceTypes.offerNumber && !!insuranceNumber) {
      this.requestPaymentDetails();
    }
  }

  requestPaymentDetails = debounce(() => {
    const { getPolicyPaymentDetails, getOfferPaymentDetails } = this.props;
    const { type } = this.state;

    if (type === insuranceTypes.policyNumber) {
      getPolicyPaymentDetails({
        ...this.state
      }).then(details => {
        this.setState({ details });
      });
    } else if (type === insuranceTypes.offerNumber) {
      getOfferPaymentDetails({
        ...this.state
      }).then(details => {
        this.setState({ details });
      });
    }
  }, CALC_API_DEBOUNCE_DURATION);

  componentDidMount() {
    animateScroll.scrollToTop({ duration: 0 });
  }

  render() {
    const { type, insuranceNumber, birthdate, submitted, validForm, isMobile } = this.state;
    const { backLink } = this.props;
    const insuranceLabels = ['Policy number', 'Offer number'];
    const insuranceOptions = insuranceLabels.map(value => {
      return { value, label: i18n(value) };
    });

    return (
      <form
        className={`page-step-wrapper page-step-wrapper--narrow ${submitted ? 'submitted' : ''}`}
        ref="form"
        onSubmit={this.handleSubmit}
      >
        <Section header={i18n('Type')}>
          {isMobile ? (
            <DropdownField
              name="association"
              className="association-select col-md-8"
              options={insuranceOptions}
              required
              ref="type"
              value={insuranceLabels[type]}
              onChange={data => this.handleDataChange(data === insuranceLabels[0] ? 0 : 1, 'type')}
            />
          ) : (
            <RadioButtonGroup
              required={true}
              useGrid={true}
              id="policyNumber"
              value={type}
              onChange={data => this.handleDataChange(data, 'type')}
              options={[
                {
                  label: insuranceOptions[insuranceTypes.policyNumber].label,
                  value: insuranceTypes.policyNumber
                },
                {
                  label: insuranceOptions[insuranceTypes.offerNumber].label,
                  value: insuranceTypes.offerNumber
                }
              ]}
            />
          )}
        </Section>
        <Section header={i18n('Details')}>
          <TextField
            label={type === insuranceTypes.policyNumber ? i18n('Policy number') : i18n('Offer number')}
            name="number"
            className="col-xs-12 col-md-4"
            value={insuranceNumber}
            onChange={data => this.handleDataChange(data, 'insuranceNumber')}
            required
            pattern={numbersOnly}
            key={`insurance_number`}
            maxLength={31}
          />
          {type === insuranceTypes.policyNumber && (
            <TextField
              label={i18n('Date of birth')}
              name="birthdate"
              ref="birthdate"
              className="col-xs-12 col-md-4"
              date
              required
              minDate={moment().add(-100, 'year')}
              maxDate={moment().add(-18, 'year')}
              onWrongDate={wrongDate => this.setState({ wrongDate })}
              onChange={data => this.handleDataChange(data, 'birthdate')}
              value={birthdate}
            />
          )}
        </Section>
        <NavigationButtons
          backLink={backLink}
          nextLink={{
            go: e => {
              this.setState({
                submitted: true,
                validForm: this.refs.form.checkValidity && this.refs.form.checkValidity()
              });

              Object.keys(this.refs).forEach(key => {
                if (this.refs[key].onBlur) {
                  this.refs[key].onBlur();
                }
              });

              if (this.refs.form.checkValidity && this.refs.form.checkValidity()) {
                toast.dismiss();
                this.handleSubmit();
              } else {
                toast.error(<ErrorMessage message={i18n('Please check your data')} />);
              }
            }
          }}
        />
      </form>
    );
  }
}

ContractTypeData.defaultProps = defaultProps;
ContractTypeData.propTypes = propTypes;

export default ContractTypeData;
